"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fetchAllTransactions = exports.getAccountShape = void 0;
// @flow
var bignumber_js_1 = require("bignumber.js");
var invariant_1 = __importDefault(require("invariant"));
var logs_1 = require("@ledgerhq/logs");
var bs58check_1 = __importDefault(require("bs58check"));
var blake2b_1 = __importDefault(require("blake2b"));
var account_1 = require("../../account");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var operation_1 = require("../../operation");
var account_2 = require("../../account");
var tzkt_1 = __importDefault(require("./api/tzkt"));
var env_1 = require("../../env");
function reconciliatePublicKey(publicKey, initialAccount) {
    if (publicKey)
        return publicKey;
    if (initialAccount) {
        var xpubOrAddress = (0, account_2.decodeAccountId)(initialAccount.id).xpubOrAddress;
        return xpubOrAddress;
    }
    throw new Error("publicKey wasn't properly restored");
}
var encodeAddress = function (publicKey) {
    var curve = 0;
    var curveData = {
        pkB58Prefix: Buffer.from([13, 15, 37, 217]),
        pkhB58Prefix: Buffer.from([6, 161, 159]),
        compressPublicKey: function (publicKey, curve) {
            publicKey = publicKey.slice(0);
            publicKey[0] = curve;
            return publicKey;
        }
    };
    var publicKeyBuf = curveData.compressPublicKey(publicKey, curve);
    var key = publicKeyBuf.slice(1);
    var keyHashSize = 20;
    var hash = (0, blake2b_1["default"])(keyHashSize);
    hash.update(key);
    hash.digest((hash = Buffer.alloc(keyHashSize)));
    var address = bs58check_1["default"].encode(Buffer.concat([curveData.pkhB58Prefix, hash]));
    return address;
};
function isStringHex(s) {
    for (var i = 0; i < s.length; i += 2) {
        var ss = s.slice(i, i + 2);
        var x = parseInt(ss, 16);
        if (Number.isNaN(x)) {
            return false;
        }
    }
    return true;
}
var getAccountShape = function (infoInput) { return __awaiter(void 0, void 0, void 0, function () {
    var initialAccount, rest, currency, derivationMode, publicKey, hex, address, accountId, initialStableOperations, mostRecentStableOperation, lastId, apiAccountPromise, blocksCountPromise, _a, apiAccount, blockHeight, fullySupported, apiOperations, _b, revealed, counter, tezosResources, balance, subAccounts, newOps, operations, accountShape;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                initialAccount = infoInput.initialAccount, rest = infoInput.rest, currency = infoInput.currency, derivationMode = infoInput.derivationMode;
                publicKey = reconciliatePublicKey(rest === null || rest === void 0 ? void 0 : rest.publicKey, initialAccount);
                (0, invariant_1["default"])(isStringHex(publicKey), "Please reimport your Tezos accounts");
                hex = Buffer.from(publicKey, "hex");
                address = encodeAddress(hex);
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: publicKey,
                    derivationMode: derivationMode
                });
                initialStableOperations = initialAccount && initialAccount.id === accountId
                    ? initialAccount.operations
                    : [];
                mostRecentStableOperation = initialStableOperations[0];
                lastId = initialAccount &&
                    (0, account_2.areAllOperationsLoaded)(initialAccount) &&
                    mostRecentStableOperation
                    ? mostRecentStableOperation.extra.id || undefined
                    : undefined;
                apiAccountPromise = tzkt_1["default"].getAccountByAddress(address);
                blocksCountPromise = tzkt_1["default"].getBlockCount();
                return [4 /*yield*/, Promise.all([
                        apiAccountPromise,
                        blocksCountPromise,
                    ])];
            case 1:
                _a = __read.apply(void 0, [_c.sent(), 2]), apiAccount = _a[0], blockHeight = _a[1];
                if (apiAccount.type === "empty") {
                    return [2 /*return*/, {
                            id: accountId,
                            xpub: publicKey,
                            freshAddress: address,
                            blockHeight: blockHeight,
                            lastSyncDate: new Date(),
                            tezosResources: {
                                revealed: false,
                                counter: 0
                            }
                        }];
                }
                fullySupported = apiAccount.type === "user";
                if (!fullySupported) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.fetchAllTransactions)(address, lastId)];
            case 2:
                _b = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                _b = [];
                _c.label = 4;
            case 4:
                apiOperations = _b;
                revealed = apiAccount.revealed, counter = apiAccount.counter;
                tezosResources = {
                    revealed: revealed,
                    counter: counter
                };
                balance = new bignumber_js_1.BigNumber(apiAccount.balance);
                subAccounts = [];
                newOps = apiOperations
                    .map(txToOp({ address: address, accountId: accountId }))
                    .filter(Boolean);
                operations = (0, jsHelpers_1.mergeOps)(initialStableOperations, newOps);
                accountShape = {
                    id: accountId,
                    xpub: publicKey,
                    freshAddress: address,
                    operations: operations,
                    balance: balance,
                    subAccounts: subAccounts,
                    spendableBalance: balance,
                    blockHeight: blockHeight,
                    lastSyncDate: new Date(),
                    tezosResources: tezosResources
                };
                return [2 /*return*/, accountShape];
        }
    });
}); };
exports.getAccountShape = getAccountShape;
var txToOp = function (_a) {
    var address = _a.address, accountId = _a.accountId;
    return function (tx) {
        var _a, _b, _c, _d;
        var type;
        var maybeValue;
        var senders = [];
        var recipients = [];
        var hasFailed = tx.status ? tx.status !== "applied" : false;
        switch (tx.type) {
            case "transaction": {
                var initiator = (_a = tx.initiator) === null || _a === void 0 ? void 0 : _a.address;
                var from = (_b = tx.sender) === null || _b === void 0 ? void 0 : _b.address;
                var to = (_c = tx.target) === null || _c === void 0 ? void 0 : _c.address;
                if (from !== address && to !== address && initiator !== address) {
                    // failsafe for a case that shouldn't happen.
                    console.warn("found tx is unrelated to account! " + tx.hash);
                    return null;
                }
                senders = [from || initiator || ""];
                recipients = [to || ""];
                if ((from === address && to === address) || // self tx
                    (from !== address && to !== address) // initiator but not in from/to
                ) {
                    // we just pay fees in that case
                    type = "FEES";
                }
                else {
                    type = to === address ? "IN" : "OUT";
                    if (!hasFailed) {
                        maybeValue = new bignumber_js_1.BigNumber(tx.amount || 0);
                        if (maybeValue.eq(0)) {
                            type = "FEES";
                        }
                    }
                }
                break;
            }
            case "delegation":
                type = tx.newDelegate ? "DELEGATE" : "UNDELEGATE";
                senders = [address];
                // convention was to use recipient for the new delegation address or "" if undelegation
                recipients = [tx.newDelegate ? tx.newDelegate.address : ""];
                break;
            case "reveal":
                type = "REVEAL";
                senders = [address];
                recipients = [address];
                break;
            case "migration":
                type = tx.balanceChange < 0 ? "OUT" : "IN";
                maybeValue = new bignumber_js_1.BigNumber(Math.abs(tx.balanceChange || 0));
                senders = [address];
                recipients = [address];
                break;
            case "origination":
                type = "CREATE";
                maybeValue = new bignumber_js_1.BigNumber(tx.contractBalance || 0);
                senders = [address];
                recipients = [((_d = tx.originatedContract) === null || _d === void 0 ? void 0 : _d.address) || ""];
                break;
            case "activation":
                type = "IN";
                senders = [address];
                recipients = [address];
                maybeValue = new bignumber_js_1.BigNumber(tx.balance || 0);
                break;
            // TODO more type of tx
            default:
                console.warn("unsupported tx:", tx);
                return null;
        }
        var hash = tx.hash;
        var id = tx.id, allocationFee = tx.allocationFee, bakerFee = tx.bakerFee, storageFee = tx.storageFee, blockHeight = tx.level, blockHash = tx.block, timestamp = tx.timestamp, storageLimit = tx.storageLimit, gasLimit = tx.gasLimit;
        if (!hash) {
            // in migration case, there is no hash...
            hash = "";
        }
        var value = maybeValue || new bignumber_js_1.BigNumber(0);
        if (type === "IN" && value.eq(0)) {
            return; // not interesting op
        }
        var fee = new bignumber_js_1.BigNumber(bakerFee || 0);
        if (!hasFailed) {
            fee = fee.plus(allocationFee || 0).plus(storageFee || 0);
        }
        if (type !== "IN") {
            value = value.plus(fee);
        }
        return {
            id: (0, operation_1.encodeOperationId)(accountId, hash, type),
            hash: hash,
            type: type,
            value: value,
            fee: fee,
            senders: senders,
            recipients: recipients,
            blockHeight: blockHeight,
            blockHash: blockHash,
            accountId: accountId,
            date: new Date(timestamp),
            extra: { gasLimit: gasLimit, storageLimit: storageLimit, id: id },
            hasFailed: hasFailed
        };
    };
};
var fetchAllTransactions = function (address, lastId) { return __awaiter(void 0, void 0, void 0, function () {
    var txs, maxIteration, r, last;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                txs = [];
                maxIteration = (0, env_1.getEnv)("TEZOS_MAX_TX_QUERIES");
                _a.label = 1;
            case 1: return [4 /*yield*/, tzkt_1["default"].getAccountOperations(address, { lastId: lastId, sort: 0 })];
            case 2:
                r = _a.sent();
                if (r.length === 0)
                    return [2 /*return*/, txs];
                txs = txs.concat(r);
                last = txs[txs.length - 1];
                if (!last)
                    return [2 /*return*/, txs];
                lastId = last.id;
                if (!lastId) {
                    (0, logs_1.log)("tezos", "id missing!");
                    return [2 /*return*/, txs];
                }
                _a.label = 3;
            case 3:
                if (--maxIteration) return [3 /*break*/, 1];
                _a.label = 4;
            case 4: return [2 /*return*/, txs];
        }
    });
}); };
exports.fetchAllTransactions = fetchAllTransactions;
//# sourceMappingURL=synchronisation.js.map